import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getInstitutionList } from "../services/institutionService";
import { InstitutionListItem } from "../types/institution";

export const useInstitutionTransmissions = () => {
  const [institutions, setInstitutions] = useState<InstitutionListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchInstitutions = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getInstitutionList();
      setInstitutions(response.institutions);
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "기관 목록을 불러오는데 실패했습니다.";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstitutions();
  }, []);

  return {
    institutions,
    loading,
    error,
    refetch: fetchInstitutions,
  };
};
